import { WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Zoom from '@material-ui/core/Zoom';
import * as React from 'react';

import { IPortalELearning } from '../actions/portal';
import i18n from '../resources/i18n';

const styles = (theme: Theme) =>
	createStyles({
		card: {
			height: '100%',
			width: 200,
		},
		content: {
			padding: theme.spacing(1),
		},
		eLearningTitle: {
			color: theme.palette.primary.main,
			fontSize: '108%',
			marginBottom: theme.spacing(1),
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			wordBreak: 'break-all',
		},
		media: {
			height: 0,
			paddingTop: '56.25%',
		},
	});

interface IPortalNoticeCardProps {
	eLearning: IPortalELearning;
	handleShowDetailDialog: (e: React.MouseEvent<HTMLElement>) => void;
	handleTrainingClick: (e: React.MouseEvent<HTMLElement>) => void;
}
interface IProps
	extends React.Props<{}>,
		WithStyles<typeof styles>,
		IPortalNoticeCardProps {}

/**
 * お知らせカード形式
 * @param props
 */
const PortalNoticeCard: React.FC<IProps> = props => {
	const {
		classes,
		eLearning,
		handleShowDetailDialog,
		handleTrainingClick,
	} = props;

	const openTimes = `${eLearning.showOpenStartDate} ${i18n.t(
		'PortalNoticeCard_0001'
	)} ${eLearning.showOpenEndDate}`;

	return (
		<Zoom in={true}>
			<Card className={classes.card}>
				<CardContent className={classes.content}>
					<Tooltip title={eLearning.title} placement="top-start">
						<Typography
							variant="h5"
							component="h2"
							className={classes.eLearningTitle}
							data-careerid={eLearning.careerID}
							onClick={handleShowDetailDialog}
						>
							{eLearning.title}
						</Typography>
					</Tooltip>
					<Grid container={true} alignItems="flex-end">
						<Grid item={true}>
							<Typography component="p" noWrap={true}>
								{i18n.t('PortalNoticeCard_0002') + ': '}
							</Typography>
						</Grid>
						<Grid item={true} style={{ flexGrow: 1 }}>
							<Progress progress={eLearning.progress} />
						</Grid>
					</Grid>
					<Typography component="p">
						{i18n.t('PortalNoticeCard_0003')}: {openTimes}
					</Typography>
				</CardContent>
				{eLearning.aplType !== 0 &&
					(eLearning.contentFlg === 1 ||
						eLearning.enqueteFlg === 1 ||
						eLearning.reportFlg === 1) &&
					eLearning.externalCourseType !== 1 && (
						<CardActions>
							<Button
								size="small"
								color="primary"
								variant="contained"
								onClick={handleTrainingClick}
							>
								{i18n.t('PortalNoticeCard_0004')}
							</Button>
						</CardActions>
					)}
				{eLearning.aplType !== 0 &&
					(eLearning.contentFlg === 1 ||
						eLearning.enqueteFlg === 1 ||
						eLearning.reportFlg === 1) &&
					eLearning.externalCourseType === 1 && (
						<CardActions>
							<Button
								size="small"
								color="default"
								variant="contained"
								onClick={handleTrainingClick}
							>
								{i18n.t('PortalNoticeCard_0005')}
							</Button>
						</CardActions>
					)}
			</Card>
		</Zoom>
	);
};

const Progress: React.FC<{ progress: string }> = props => {
	if (/^(\-|\+)?([0-9]+)$/.test(props.progress) === false) {
		return (
			<Typography component="p" noWrap={true}>
				{props.progress}
			</Typography>
		);
	}

	const progress = +props.progress;
	return (
		<div
			style={{
				backgroundColor: '#dadada',
				borderRadius: '2px',
				display: 'inline-block',
				height: 20,
				width: '100%',
			}}
		>
			<div
				style={{
					backgroundColor:
						progress > 66
							? '#85cc00'
							: progress > 33
							? '#ffbf00'
							: '#ff2e00',
					borderRadius: '2px',
					display: 'inline-block',
					height: '100%',
					transition: 'all .2s ease-out',
					width: `${progress}%`,
				}}
			>{`${progress}%`}</div>
		</div>
	);
};

export default withStyles(styles)(PortalNoticeCard) as React.ComponentType<
	IPortalNoticeCardProps
>;



// WEBPACK FOOTER //
// ./src/components/PortalNoticeCard.tsx